import { useState, useCallback } from 'react';
import { Outlet } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Sidebar } from './Sidebar';

export function AppShell() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const closeSidebar = useCallback(() => setSidebarOpen(false), []);

  return (
    <div className="flex h-screen overflow-hidden bg-background">
      {/* Skip to content (F5) */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:z-50 focus:rounded focus:bg-teal focus:px-4 focus:py-2 focus:text-white"
      >
        Skip to main content
      </a>

      {/* Mobile hamburger */}
      <button
        type="button"
        className="fixed left-3 top-3 z-50 rounded-md bg-card p-2 shadow-md md:hidden"
        onClick={() => setSidebarOpen(!sidebarOpen)}
        aria-label={sidebarOpen ? 'Close navigation' : 'Open navigation'}
      >
        {sidebarOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
      </button>

      {/* Mobile overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-30 bg-black/50 md:hidden"
          onClick={closeSidebar}
          aria-hidden="true"
        />
      )}

      {/* Sidebar — desktop always visible, mobile slides in */}
      <div className={`
        fixed inset-y-0 left-0 z-40 w-64
        transform transition-transform duration-200 ease-in-out
        md:relative md:translate-x-0
        ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'}
      `}>
        <Sidebar onNavClick={closeSidebar} />
      </div>

      <main id="main-content" className="flex-1 overflow-y-auto">
        <div className="mx-auto max-w-7xl p-6 pt-14 md:pt-6">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
